var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ],
      attrs: { id: "skillpasscomponent" }
    },
    [
      _c("div", { staticClass: "row align-items-center mb-3" }, [
        _c("div", { staticClass: "col-8" }, [
          _c("div", { staticClass: "px-2" }, [
            _c("div", { staticClass: "input-group search_tasks_txtbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchText,
                    expression: "searchText"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: "Search Services or Skills",
                  "aria-label": "Search tasks"
                },
                domProps: { value: _vm.searchText },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.dosearch()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchText = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-append" }, [
                _vm.searchTextFlag
                  ? _c("span", { staticClass: "input-group-text" }, [
                      _c("i", {
                        staticClass: "fa fa-close",
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            return _vm.clearText()
                          }
                        }
                      })
                    ])
                  : _c("span", { staticClass: "input-group-text" }, [
                      _c("i", {
                        staticClass: "fa fa-search",
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            return _vm.dosearch()
                          }
                        }
                      })
                    ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-2 p-0",
            staticStyle: { "padding-right": "5px !important" }
          },
          [
            _c("div", { staticClass: "text-right " }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.openTaskList()
                    }
                  }
                },
                [_vm._v("Task List")]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "col-2 p-0",
          staticStyle: { "padding-right": "20px !important" }
        })
      ]),
      _vm._v(" "),
      _vm.tasklists_loading == true && _vm.tasklists_focus_loading == true
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "7px",
                float: "left",
                width: "100%"
              }
            },
            [
              _c(
                "div",
                { staticClass: "col-3 p-0 section-title float-left" },
                [_c("PuSkeleton", { attrs: { count: 1 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-3 p-0 text-align-right bold float-right",
                  staticStyle: { "padding-right": "5px !important" }
                },
                [_c("PuSkeleton", { attrs: { count: 1 } })],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(3, function(option) {
        return _vm.tasklists_loading == true &&
          _vm.tasklists_focus_loading == true
          ? _c(
              "div",
              {
                staticClass: "col-md-12 p-0",
                staticStyle: {
                  "margin-top": "10px",
                  "padding-left": "10px !important",
                  "padding-right": "5px !important"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "subtask-wrapper",
                    staticStyle: { "padding-bottom": "5px" }
                  },
                  [
                    _c("div", { staticClass: "pt-2" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 pl-2 pr-0 float-left" },
                        [
                          _c(
                            "div",
                            { staticClass: "pr-2" },
                            [_c("PuSkeleton", { attrs: { count: 1 } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-12 pt-2 override-padding counter_heading-list heading-wrapper",
                              staticStyle: {
                                "padding-right": "3px",
                                "margin-bottom": "0px"
                              }
                            },
                            [_c("PuSkeleton", { attrs: { count: 1 } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-12 pt-1 override-padding counter_heading-list heading-wrapper",
                              staticStyle: {
                                "padding-right": "3px",
                                "margin-bottom": "0px",
                                "padding-left": "20px"
                              }
                            },
                            [_c("PuSkeleton", { attrs: { count: 1 } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-12 pt-1 override-padding counter_heading-list heading-wrapper",
                              staticStyle: {
                                "padding-right": "3px",
                                "margin-bottom": "0px",
                                "padding-left": "20px"
                              }
                            },
                            [_c("PuSkeleton", { attrs: { count: 1 } })],
                            1
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.focusedSubtasks.length > 0
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "7px",
                float: "left",
                width: "100%"
              }
            },
            [
              _c("div", { staticClass: "col-6 p-0 section-title float-left" }, [
                _vm._v("\n        Focused Sections\n    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-6 p-0 text-align-right bold float-right",
                  staticStyle: { "padding-right": "5px !important" }
                },
                [_vm._v(_vm._s(_vm.taskListsName) + " ")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.focusedSubtasks.length > 0
        ? _c(
            "div",
            {
              staticClass: "col-md-12 counter_subtask-list p-0",
              staticStyle: {
                "margin-top": "10px",
                "padding-left": "10px !important",
                "padding-right": "5px !important"
              }
            },
            _vm._l(_vm.focusedSubtasks, function(focusedSubtask, fsindex) {
              return _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "subtask-wrapper",
                    staticStyle: { "padding-bottom": "5px" },
                    attrs: { id: "subtask-wrapper-skill-" + focusedSubtask.id }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "panel-title focused-section-highlight" },
                      [
                        _c("div", { staticClass: "col-12 p-0 float-left" }, [
                          _c(
                            "div",
                            {
                              staticClass: "float-left p-0",
                              staticStyle: {
                                "text-align": "left !important",
                                padding: "0px 0px 0px 0px !important",
                                width: "5%"
                              }
                            },
                            [
                              _c(
                                "b-link",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value:
                                        "collapse-focused-skill-" +
                                        focusedSubtask.id,
                                      expression:
                                        "'collapse-focused-skill-' + focusedSubtask.id"
                                    }
                                  ],
                                  staticClass: "p-0",
                                  staticStyle: {
                                    "padding-left": "10px !important"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getFocusedSecondFontIconSkill(
                                        focusedSubtask.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-angle-down angle-class",
                                    attrs: {
                                      id:
                                        "angle-focused-skill-" +
                                        focusedSubtask.id,
                                      "aria-hidden": "true"
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "float-left col-4 p-0" },
                            [
                              _c(
                                "b-link",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value:
                                        "collapse-focused-skill-" +
                                        focusedSubtask.id,
                                      expression:
                                        "'collapse-focused-skill-' + focusedSubtask.id"
                                    }
                                  ],
                                  staticClass: "p-0",
                                  staticStyle: {
                                    "padding-left": "10px !important"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getFocusedSecondFontIconSkill(
                                        focusedSubtask.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(focusedSubtask.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "float-left p-0 text-center save-goal-button",
                              staticStyle: {
                                width: "14%",
                                "padding-top": "1px !important"
                              }
                            },
                            [_vm._v("\n               \n            ")]
                          ),
                          _vm._v(" "),
                          focusedSubtask.id != 99999
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-left col-3",
                                  staticStyle: {
                                    "text-align": "left",
                                    padding: "0px 0px 0px 0px"
                                  }
                                },
                                [
                                  _c(
                                    "b-link",
                                    {
                                      directives: [
                                        {
                                          name: "b-toggle",
                                          rawName: "v-b-toggle",
                                          value:
                                            "collapse-focused-skill-" +
                                            focusedSubtask.id,
                                          expression:
                                            "'collapse-focused-skill-' + focusedSubtask.id"
                                        }
                                      ],
                                      staticClass: "p-0",
                                      staticStyle: {
                                        "padding-left": "10px !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.getFocusedSecondFontIconSkill(
                                            focusedSubtask.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-9 pr-0" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "progress progress_step"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "progress-bar",
                                                  staticStyle: {
                                                    "background-color":
                                                      "#B4E6FA !important"
                                                  },
                                                  style:
                                                    "width: " +
                                                    focusedSubtask.subtaskCompetentPercent +
                                                    "%;",
                                                  attrs: {
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 pl-0 pr-1 text-right",
                                            staticStyle: {
                                              "font-size": "13px",
                                              "margin-left": "4px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  focusedSubtask.subtaskCompetentPercent
                                                ) +
                                                "%\n                  "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          focusedSubtask.enableAddRep == true
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-left col-2 p-0",
                                  staticStyle: {
                                    "padding-top": "3px !important"
                                  }
                                },
                                [_vm._v("\n               \n            ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          focusedSubtask.id != 99999
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-right p-0 star-class",
                                  staticStyle: {
                                    width: "5%",
                                    "margin-top": "2px"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-star",
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "#ee4200"
                                    },
                                    attrs: {
                                      "aria-hidden": "true",
                                      "data-toggle": "tooltip",
                                      "data-placement": "bottom",
                                      title: "Remove from Focused Section"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-collapse",
                      {
                        staticClass: "mt-2 ",
                        staticStyle: {
                          "border-top": "1px solid #C8C7C8",
                          float: "left",
                          width: "100%",
                          "margin-top": "0px !important"
                        },
                        attrs: {
                          id: "collapse-focused-skill-" + focusedSubtask.id
                        }
                      },
                      [
                        _c("b-card", [
                          focusedSubtask.headings.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_heading-list heading-wrapper"
                                },
                                _vm._l(focusedSubtask.headings, function(
                                  focusedHeading,
                                  hindex
                                ) {
                                  return _c(
                                    "div",
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          directives: [
                                            {
                                              name: "b-toggle",
                                              rawName: "v-b-toggle",
                                              value:
                                                "collapse-focused-skill-" +
                                                focusedSubtask.id +
                                                "-" +
                                                focusedHeading.id,
                                              expression:
                                                "'collapse-focused-skill-' + focusedSubtask.id + '-' + focusedHeading.id"
                                            }
                                          ],
                                          staticClass: "sub-heading",
                                          staticStyle: {
                                            "border-bottom":
                                              "1px solid #C8C7C8",
                                            "border-radius": "0",
                                            "padding-right": "10px"
                                          },
                                          attrs: {
                                            variant: "primary",
                                            size: "sm"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getFocusedFontIconSkill(
                                                focusedSubtask.id +
                                                  "-" +
                                                  focusedHeading.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-angle-up",
                                            attrs: {
                                              id:
                                                "angle-focused-skill-" +
                                                focusedSubtask.id +
                                                "-" +
                                                focusedHeading.id,
                                              "aria-hidden": "true"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(focusedHeading.name) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-collapse",
                                        {
                                          staticClass: "mt-2 task-wrapper",
                                          attrs: {
                                            id:
                                              "collapse-focused-skill-" +
                                              focusedSubtask.id +
                                              "-" +
                                              focusedHeading.id
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 override-padding counter_task-list"
                                            },
                                            [
                                              _vm._l(
                                                focusedHeading.tasks,
                                                function(task, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "custom-checkbox"
                                                    },
                                                    [
                                                      _c(
                                                        "b-card",
                                                        {
                                                          staticClass:
                                                            "modal-task"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "71%",
                                                                    "padding-left":
                                                                      "10px"
                                                                  }
                                                                },
                                                                [
                                                                  task.completed ==
                                                                  1
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "float-left",
                                                                          staticStyle: {
                                                                            width:
                                                                              "2.2%",
                                                                            "margin-top":
                                                                              "5px",
                                                                            "padding-left":
                                                                              "32px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              staticClass:
                                                                                "custom-control-input",
                                                                              attrs: {
                                                                                name:
                                                                                  "skill_pass_tasks",
                                                                                id:
                                                                                  task.id,
                                                                                type:
                                                                                  "checkbox",
                                                                                value:
                                                                                  "1",
                                                                                disabled:
                                                                                  "disabled"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  task.id
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "label",
                                                                            {
                                                                              staticClass:
                                                                                "custom-control-label",
                                                                              attrs: {
                                                                                for:
                                                                                  task.id
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "float-left",
                                                                          staticStyle: {
                                                                            width:
                                                                              "2.2%",
                                                                            "margin-top":
                                                                              "2px",
                                                                            "padding-left":
                                                                              "32px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              staticClass:
                                                                                "custom-control-input",
                                                                              attrs: {
                                                                                name:
                                                                                  "skill_pass_tasks",
                                                                                id:
                                                                                  task.id,
                                                                                type:
                                                                                  "checkbox",
                                                                                value:
                                                                                  "1"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  task.id
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.changeSkillPassTasks(
                                                                                    task.id,
                                                                                    task.description,
                                                                                    focusedSubtask.id,
                                                                                    focusedSubtask.name,
                                                                                    focusedHeading.id,
                                                                                    focusedHeading.name,
                                                                                    $event
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "label",
                                                                            {
                                                                              staticClass:
                                                                                "custom-control-label",
                                                                              attrs: {
                                                                                for:
                                                                                  task.id
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "float-right",
                                                                      staticStyle: {
                                                                        width:
                                                                          "91.8%"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "task-title",
                                                                          staticStyle: {
                                                                            "padding-left":
                                                                              "0",
                                                                            width:
                                                                              "96%"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "counter_task-list__counter"
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                                " +
                                                                              _vm._s(
                                                                                task.description
                                                                              ) +
                                                                              "\n                              "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              task.goal.goal_rep
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        " task_goal_text",
                                                                      staticStyle: {
                                                                        width:
                                                                          "12%"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          task
                                                                            .goal
                                                                            .task_rep +
                                                                            "/" +
                                                                            task
                                                                              .goal
                                                                              .goal_rep +
                                                                            " Reps"
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              task.goal
                                                                .goal_rep_competency
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        " task_goal_text",
                                                                      staticStyle: {
                                                                        width:
                                                                          "12%",
                                                                        "padding-right":
                                                                          "5px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          task
                                                                            .goal
                                                                            .task_rep_competency +
                                                                            "/" +
                                                                            task
                                                                              .goal
                                                                              .goal_rep_competency +
                                                                            " Comp"
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticStyle: { clear: "both" }
                                              })
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          focusedSubtask.tasks.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_task-list task-wrapper",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [
                                  _vm._l(focusedSubtask.tasks, function(
                                    task,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "custom-checkbox"
                                      },
                                      [
                                        _c(
                                          "b-card",
                                          { staticClass: "modal-task" },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "71%",
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [
                                                  task.completed == 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "float-left",
                                                          staticStyle: {
                                                            width: "2.2%",
                                                            "margin-top": "5px",
                                                            "padding-left":
                                                              "32px"
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "custom-control-input",
                                                            attrs: {
                                                              name:
                                                                "skill_pass_tasks",
                                                              id: task.id,
                                                              type: "checkbox",
                                                              value: "1",
                                                              disabled:
                                                                "disabled"
                                                            },
                                                            domProps: {
                                                              value: task.id
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("label", {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: task.id
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "float-left",
                                                          staticStyle: {
                                                            width: "2.2%",
                                                            "margin-top": "2px",
                                                            "padding-left":
                                                              "32px"
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "custom-control-input",
                                                            attrs: {
                                                              name:
                                                                "skill_pass_tasks",
                                                              id: task.id,
                                                              type: "checkbox",
                                                              value: "1"
                                                            },
                                                            domProps: {
                                                              value: task.id
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.changeSkillPassTasks(
                                                                  task.id,
                                                                  task.description,
                                                                  focusedSubtask.id,
                                                                  focusedSubtask.name,
                                                                  "",
                                                                  "",
                                                                  $event
                                                                )
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("label", {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: task.id
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "float-right",
                                                      staticStyle: {
                                                        width: "91.8%"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "task-title",
                                                          staticStyle: {
                                                            "padding-left": "0",
                                                            width: "96%"
                                                          }
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "counter_task-list__counter"
                                                          }),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                task.description
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              task.goal.goal_rep
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        " task_goal_text",
                                                      staticStyle: {
                                                        width: "12%"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          task.goal.task_rep +
                                                            "/" +
                                                            task.goal.goal_rep +
                                                            " Reps"
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              task.goal.goal_rep_competency
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        " task_goal_text",
                                                      staticStyle: {
                                                        width: "12%",
                                                        "padding-right": "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          task.goal
                                                            .task_rep_competency +
                                                            "/" +
                                                            task.goal
                                                              .goal_rep_competency +
                                                            " Comp"
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticStyle: { clear: "both" } })
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.focusedSubtasks.length > 0 && _vm.tasklists_focus_loading == false
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "7px",
                float: "left",
                width: "100%"
              }
            },
            [
              _c("div", { staticClass: "col-6 p-0 section-title float-left" }, [
                _vm._v("\n        Remaining Sections\n    ")
              ])
            ]
          )
        : _vm.tasklists_focus_loading == false &&
          _vm.focusedSubtasks.length == 0 &&
          _vm.searchTextFlag == true
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "7px",
                float: "left",
                width: "100%"
              }
            },
            [
              _c("div", { staticClass: "col-6 p-0 section-title float-left" }, [
                _vm._v("\n        All Sections\n    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-6 p-0 text-align-right bold float-right",
                  staticStyle: { "padding-right": "5px !important" }
                },
                [_vm._v(_vm._s(_vm.taskListsName) + " ")]
              )
            ]
          )
        : _vm.tasklists_focus_loading == false &&
          _vm.focusedSubtasks.length == 0
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "7px",
                float: "left",
                width: "100%"
              }
            },
            [
              _c("div", { staticClass: "col-6 p-0 section-title float-left" }, [
                _vm._v("\n        All Sections\n    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-6 p-0 text-align-right bold float-right",
                  staticStyle: { "padding-right": "5px !important" }
                },
                [_vm._v(_vm._s(_vm.taskListsName) + " ")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.subtasks.length > 0
        ? _c(
            "div",
            {
              staticClass: "col-md-12 counter_subtask-list",
              staticStyle: {
                "margin-top": "10px",
                "padding-left": "10px !important",
                "padding-right": "5px !important"
              }
            },
            _vm._l(_vm.subtasks, function(subtask, stindex) {
              return _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "subtask-wrapper",
                    staticStyle: { "padding-bottom": "5px" },
                    attrs: { id: "subtask-wrapper-skill-" + subtask.id }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "panel-title focused-section-highlight" },
                      [
                        _c("div", { staticClass: "col-12 p-0 float-left" }, [
                          _c(
                            "div",
                            {
                              staticClass: "float-left p-0",
                              staticStyle: {
                                "text-align": "left !important",
                                padding: "0px 0px 0px 0px !important",
                                width: "5%"
                              }
                            },
                            [
                              _c(
                                "b-link",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value: "collapse-skill-" + subtask.id,
                                      expression:
                                        "'collapse-skill-' + subtask.id"
                                    }
                                  ],
                                  staticClass: "p-0",
                                  staticStyle: {
                                    "padding-left": "10px !important"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getSecondFontIconSkill(
                                        subtask.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-angle-down angle-class",
                                    attrs: {
                                      id: "angle-skill-" + subtask.id,
                                      "aria-hidden": "true"
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "float-left col-4 p-0" },
                            [
                              _c(
                                "b-link",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value: "collapse-skill-" + subtask.id,
                                      expression:
                                        "'collapse-skill-' + subtask.id"
                                    }
                                  ],
                                  staticClass: "p-0",
                                  staticStyle: {
                                    "padding-left": "10px !important"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getSecondFontIconSkill(
                                        subtask.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(subtask.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "float-left p-0 text-center save-goal-button",
                              staticStyle: {
                                width: "14%",
                                "padding-top": "1px !important"
                              }
                            },
                            [_vm._v("\n               \n            ")]
                          ),
                          _vm._v(" "),
                          subtask.id != 99999
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-left col-3",
                                  staticStyle: {
                                    "text-align": "left",
                                    padding: "0px 0px 0px 0px"
                                  }
                                },
                                [
                                  _c(
                                    "b-link",
                                    {
                                      directives: [
                                        {
                                          name: "b-toggle",
                                          rawName: "v-b-toggle",
                                          value: "collapse-skill-" + subtask.id,
                                          expression:
                                            "'collapse-skill-' + subtask.id"
                                        }
                                      ],
                                      staticClass: "p-0",
                                      staticStyle: {
                                        "padding-left": "10px !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.getSecondFontIconSkill(
                                            subtask.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-9 pr-0" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "progress progress_step"
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "progress-bar",
                                                  staticStyle: {
                                                    "background-color":
                                                      "#B4E6FA !important"
                                                  },
                                                  style:
                                                    "width: " +
                                                    subtask.subtaskCompetentPercent +
                                                    "%;",
                                                  attrs: {
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 pl-0 pr-1 text-right",
                                            staticStyle: {
                                              "font-size": "13px",
                                              "margin-left": "4px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  subtask.subtaskCompetentPercent
                                                ) +
                                                "%\n                  "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          subtask.enableAddRep == true
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-left col-2 p-0",
                                  staticStyle: {
                                    "padding-top": "3px !important"
                                  }
                                },
                                [_vm._v("\n               \n            ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          subtask.id != 99999
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-right p-0 star-class",
                                  staticStyle: {
                                    "margin-top": "2px",
                                    width: "5%"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-star-o",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      "aria-hidden": "true",
                                      "data-toggle": "tooltip",
                                      "data-placement": "bottom",
                                      title: "Remove from Focused Section"
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-collapse",
                      {
                        staticClass: "mt-2 ",
                        staticStyle: {
                          "border-top": "1px solid #C8C7C8",
                          float: "left",
                          width: "100%",
                          "margin-top": "0px !important"
                        },
                        attrs: { id: "collapse-skill-" + subtask.id }
                      },
                      [
                        _c("b-card", [
                          subtask.headings.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_heading-list heading-wrapper"
                                },
                                _vm._l(subtask.headings, function(
                                  heading,
                                  hindex
                                ) {
                                  return _c(
                                    "div",
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          directives: [
                                            {
                                              name: "b-toggle",
                                              rawName: "v-b-toggle",
                                              value:
                                                "collapse-skill-" +
                                                subtask.id +
                                                "-" +
                                                heading.id,
                                              expression:
                                                "'collapse-skill-' + subtask.id + '-' + heading.id"
                                            }
                                          ],
                                          staticClass: "sub-heading",
                                          staticStyle: {
                                            "border-bottom":
                                              "1px solid #C8C7C8",
                                            "border-radius": "0",
                                            "padding-right": "10px"
                                          },
                                          attrs: {
                                            variant: "primary",
                                            size: "sm"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getFontIconSkill(
                                                subtask.id + "-" + heading.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-angle-up",
                                            attrs: {
                                              id:
                                                "angle-skill-" +
                                                subtask.id +
                                                "-" +
                                                heading.id,
                                              "aria-hidden": "true"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(heading.name) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-collapse",
                                        {
                                          staticClass: "mt-2 task-wrapper",
                                          attrs: {
                                            id:
                                              "collapse-skill-" +
                                              subtask.id +
                                              "-" +
                                              heading.id
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 override-padding counter_task-list"
                                            },
                                            [
                                              _vm._l(heading.tasks, function(
                                                task,
                                                index
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "custom-checkbox"
                                                  },
                                                  [
                                                    _c(
                                                      "b-card",
                                                      {
                                                        staticClass:
                                                          "modal-task"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  width: "71%",
                                                                  "padding-left":
                                                                    "10px"
                                                                }
                                                              },
                                                              [
                                                                task.completed ==
                                                                1
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "float-left",
                                                                        staticStyle: {
                                                                          width:
                                                                            "2.2%",
                                                                          "margin-top":
                                                                            "5px",
                                                                          "padding-left":
                                                                            "32px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            staticClass:
                                                                              "custom-control-input",
                                                                            attrs: {
                                                                              name:
                                                                                "skill_pass_tasks",
                                                                              id:
                                                                                task.id,
                                                                              type:
                                                                                "checkbox",
                                                                              value:
                                                                                "1",
                                                                              disabled:
                                                                                "disabled"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                task.id
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "label",
                                                                          {
                                                                            staticClass:
                                                                              "custom-control-label",
                                                                            attrs: {
                                                                              for:
                                                                                task.id
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "float-left",
                                                                        staticStyle: {
                                                                          width:
                                                                            "2.2%",
                                                                          "margin-top":
                                                                            "2px",
                                                                          "padding-left":
                                                                            "32px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            staticClass:
                                                                              "custom-control-input",
                                                                            attrs: {
                                                                              name:
                                                                                "skill_pass_tasks",
                                                                              id:
                                                                                task.id,
                                                                              type:
                                                                                "checkbox",
                                                                              value:
                                                                                "1"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                task.id
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.changeSkillPassTasks(
                                                                                  task.id,
                                                                                  task.description,
                                                                                  subtask.id,
                                                                                  subtask.name,
                                                                                  heading.id,
                                                                                  heading.name,
                                                                                  $event
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "label",
                                                                          {
                                                                            staticClass:
                                                                              "custom-control-label",
                                                                            attrs: {
                                                                              for:
                                                                                task.id
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "float-right",
                                                                    staticStyle: {
                                                                      width:
                                                                        "91.8%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "task-title",
                                                                        staticStyle: {
                                                                          "padding-left":
                                                                            "0",
                                                                          width:
                                                                            "96%"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "counter_task-list__counter"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              task.description
                                                                            ) +
                                                                            "\n                              "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            task.goal
                                                              .goal_rep &&
                                                            subtask.goalEdit ==
                                                              false
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      " task_goal_text",
                                                                    staticStyle: {
                                                                      width:
                                                                        "12%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        task
                                                                          .goal
                                                                          .task_rep +
                                                                          "/" +
                                                                          task
                                                                            .goal
                                                                            .goal_rep +
                                                                          " Reps"
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            task.goal
                                                              .goal_rep_competency &&
                                                            subtask.goalEdit ==
                                                              false
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      " task_goal_text",
                                                                    staticStyle: {
                                                                      width:
                                                                        "12%",
                                                                      "padding-right":
                                                                        "5px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        task
                                                                          .goal
                                                                          .task_rep_competency +
                                                                          "/" +
                                                                          task
                                                                            .goal
                                                                            .goal_rep_competency +
                                                                          " Comp"
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticStyle: { clear: "both" }
                                              })
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          subtask.tasks.length == 0 && subtask.id == 99999
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_task-list ",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [
                                  _c("b-card", { staticClass: "modal-task " }, [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "60%",
                                            "padding-left": "80px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      No other task added.\n                    "
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          subtask.tasks.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 override-padding counter_task-list task-wrapper",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [
                                  _vm._l(subtask.tasks, function(task, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "custom-checkbox"
                                      },
                                      [
                                        _c(
                                          "b-card",
                                          { staticClass: "modal-task " },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "71%",
                                                    "padding-left": "10px"
                                                  }
                                                },
                                                [
                                                  task.completed == 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "float-left",
                                                          staticStyle: {
                                                            width: "2.2%",
                                                            "margin-top": "5px",
                                                            "padding-left":
                                                              "32px"
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "custom-control-input",
                                                            attrs: {
                                                              name:
                                                                "skill_pass_tasks",
                                                              id: task.id,
                                                              type: "checkbox",
                                                              value: "1",
                                                              disabled:
                                                                "disabled"
                                                            },
                                                            domProps: {
                                                              value: task.id
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("label", {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: task.id
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "float-left",
                                                          staticStyle: {
                                                            width: "2.2%",
                                                            "margin-top": "2px",
                                                            "padding-left":
                                                              "32px"
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "custom-control-input",
                                                            attrs: {
                                                              name:
                                                                "skill_pass_tasks",
                                                              id: task.id,
                                                              type: "checkbox",
                                                              value: "1"
                                                            },
                                                            domProps: {
                                                              value: task.id
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.changeSkillPassTasks(
                                                                  task.id,
                                                                  task.description,
                                                                  subtask.id,
                                                                  subtask.name,
                                                                  "",
                                                                  "",
                                                                  $event
                                                                )
                                                              }
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("label", {
                                                            staticClass:
                                                              "custom-control-label",
                                                            attrs: {
                                                              for: task.id
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "float-right",
                                                      staticStyle: {
                                                        width: "91.8%"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "task-title",
                                                          staticStyle: {
                                                            "padding-left": "0",
                                                            width: "96%"
                                                          }
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "counter_task-list__counter"
                                                          }),
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                task.description
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              task.goal.goal_rep &&
                                              subtask.goalEdit == false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        " task_goal_text",
                                                      staticStyle: {
                                                        width: "12%"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          task.goal.task_rep +
                                                            "/" +
                                                            task.goal.goal_rep +
                                                            " Reps"
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              task.goal.goal_rep_competency &&
                                              subtask.goalEdit == false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        " task_goal_text",
                                                      staticStyle: {
                                                        width: "12%",
                                                        "padding-right": "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          task.goal
                                                            .task_rep_competency +
                                                            "/" +
                                                            task.goal
                                                              .goal_rep_competency +
                                                            " Comp"
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticStyle: { clear: "both" } })
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { clear: "both" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-12 text-align-center",
          staticStyle: { "margin-top": "30px", "margin-bottom": "25px" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm dbAddRepsBtn1",
              on: {
                click: function($event) {
                  return _vm.openSkillPassConfirmModal()
                }
              }
            },
            [_vm._v("\n        Skill Pass\n      ")]
          ),
          _vm._v(" "),
          _vm.tasksCount == 1
            ? _c(
                "div",
                {
                  staticClass: "col-12 bold",
                  staticStyle: { "margin-top": "12px" }
                },
                [_c("u", [_vm._v(_vm._s(_vm.tasksCount) + " Task Selected")])]
              )
            : _c(
                "div",
                {
                  staticClass: "col-12 bold",
                  staticStyle: { "margin-top": "12px" }
                },
                [_c("u", [_vm._v(_vm._s(_vm.tasksCount) + " Tasks Selected")])]
              )
        ]
      ),
      _vm._v(" "),
      _c(
        "SkillPassConfirmModal",
        {
          ref: "isSkillPassConfirm",
          attrs: { isModalVisible: _vm.isSkillPassConfirmModalVisible },
          on: {
            close: function($event) {
              _vm.isSkillPassConfirmModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n        Loading...\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading12 col-11",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _vm._v(
                "\n        Skill Pass - " +
                  _vm._s(_vm.menteeShortName) +
                  "\n        "
              ),
              _c("br"),
              _vm._v(
                "\n        Task List - " +
                  _vm._s(_vm.taskListsName) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _vm._l(_vm.skillTaskSubtask, function(subtask, sindex) {
                  return _c("div", { key: sindex, staticClass: "col-12 p-0" }, [
                    subtask.tasks.length > 0
                      ? _c(
                          "div",
                          { staticClass: "col-12 p-0" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-12 p-0 bold",
                                staticStyle: {
                                  "padding-bottom": "5px !important"
                                }
                              },
                              [_vm._v(_vm._s(subtask.name))]
                            ),
                            _vm._v(" "),
                            _vm._l(subtask.tasks, function(task, tindex) {
                              return _c(
                                "div",
                                { key: tindex, staticClass: "col-12 p-0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 p-0",
                                      staticStyle: {
                                        "padding-bottom": "10px !important"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-1 float-left p-0 custom-checkbox"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.skill_pass_tasks,
                                                expression: "skill_pass_tasks"
                                              }
                                            ],
                                            staticClass: "custom-control-input",
                                            staticStyle: {
                                              "margin-top": "10px",
                                              "margin-left": "7px"
                                            },
                                            attrs: {
                                              name: "skill_pass_tasks",
                                              value: "1",
                                              id: task.id,
                                              type: "checkbox",
                                              checked: "true"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.skill_pass_tasks
                                              )
                                                ? _vm._i(
                                                    _vm.skill_pass_tasks,
                                                    "1"
                                                  ) > -1
                                                : _vm.skill_pass_tasks
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.changeSkillPassTasks(
                                                  subtask.id,
                                                  "",
                                                  task.id,
                                                  $event
                                                )
                                              },
                                              change: function($event) {
                                                var $$a = _vm.skill_pass_tasks,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = "1",
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.skill_pass_tasks = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.skill_pass_tasks = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.skill_pass_tasks = $$c
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("label", {
                                            staticClass: "custom-control-label",
                                            staticStyle: {
                                              "margin-left": "30px",
                                              "margin-top": "5px"
                                            },
                                            attrs: { for: task.id }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-11 skill-task-show float-left p-0",
                                          staticStyle: {
                                            padding: "5px 10px !important"
                                          }
                                        },
                                        [_vm._v(_vm._s(task.description))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: { clear: "both" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    subtask.headings.length > 0
                      ? _c(
                          "div",
                          { staticClass: "col-12 p-0" },
                          _vm._l(subtask.headings, function(heading, hindex) {
                            return _c(
                              "div",
                              { key: hindex, staticClass: "col-12 p-0" },
                              [
                                heading.tasks.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12 p-0" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 p-0 bold",
                                            staticStyle: {
                                              "padding-bottom": "5px !important"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(subtask.name) +
                                                " - " +
                                                _vm._s(heading.name)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(heading.tasks, function(
                                          task,
                                          tindex
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: tindex,
                                              staticClass: "col-12 p-0"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "col-12 p-0",
                                                  staticStyle: {
                                                    "padding-bottom":
                                                      "10px !important"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-1 float-left p-0 custom-checkbox"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.skill_pass_tasks,
                                                            expression:
                                                              "skill_pass_tasks"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "custom-control-input",
                                                        staticStyle: {
                                                          "margin-top": "10px",
                                                          "margin-left": "7px"
                                                        },
                                                        attrs: {
                                                          name:
                                                            "skill_pass_tasks",
                                                          value: "1",
                                                          id: task.id,
                                                          type: "checkbox",
                                                          checked: "true"
                                                        },
                                                        domProps: {
                                                          checked: Array.isArray(
                                                            _vm.skill_pass_tasks
                                                          )
                                                            ? _vm._i(
                                                                _vm.skill_pass_tasks,
                                                                "1"
                                                              ) > -1
                                                            : _vm.skill_pass_tasks
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.changeSkillPassTasks(
                                                              subtask.id,
                                                              heading.id,
                                                              task.id,
                                                              $event
                                                            )
                                                          },
                                                          change: function(
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.skill_pass_tasks,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = "1",
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.skill_pass_tasks = $$a.concat(
                                                                    [$$v]
                                                                  ))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.skill_pass_tasks = $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                              }
                                                            } else {
                                                              _vm.skill_pass_tasks = $$c
                                                            }
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("label", {
                                                        staticClass:
                                                          "custom-control-label",
                                                        staticStyle: {
                                                          "margin-left": "30px",
                                                          "margin-top": "5px"
                                                        },
                                                        attrs: { for: task.id }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-11 skill-task-show float-left p-0",
                                                      staticStyle: {
                                                        padding:
                                                          "5px 10px !important"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(task.description)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticStyle: {
                                                      clear: "both"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-12 p-0 text-align-center bold",
                    staticStyle: { "font-size": "15px", "margin-top": "10px" }
                  },
                  [
                    _vm._v(
                      "\n            Are you sure you want to skill pass?\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-12 p-0 text-align-center bold",
                    staticStyle: {
                      "padding-top": "4px !important",
                      "font-size": "15px"
                    }
                  },
                  [
                    _vm._v(
                      '\n            "This change can not be undone"\n          '
                    )
                  ]
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 override-padding",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "col-12 p-0" }, [
                _c("div", { staticClass: "col-4 float-left p-0 text-left" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-md start-button",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_vm._v("Back")]
                  )
                ]),
                _vm._v(" "),
                _vm.tasksCount == 1
                  ? _c(
                      "div",
                      { staticClass: "col-4 float-left p-0 text-align-center" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.tasksCount) +
                            " task selected\n          "
                        )
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "col-4 float-left p-0 text-align-center" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.tasksCount) +
                            " tasks selected\n          "
                        )
                      ]
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-4 float-left p-0 text-align-right" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-red btn-md start-button-red",
                        attrs: {
                          disabled: _vm.disable_confirm_btn,
                          type: "submit"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onSubmit()
                          }
                        }
                      },
                      [_vm._v("Confirm")]
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ca864d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ca864d1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/mentee_skillpass_component.vue
// module id = null
// module chunks = 